import { z } from 'zod'

export const source = z
  .object({
    provider: z.string(),
    external_id: z.string(),
    url: z.string(),
    updated_at: z.string().optional(),
  })
  .strict()
export type Source = z.infer<typeof source>

export const writeBack = z.object({ action: z.string(), args: z.unknown().optional(), at: z.string() })
export type WriteBack = z.infer<typeof writeBack>

export const gitIssueSpec = z
  .object({
    source,
    repo: z.string(),
    number: z.number().int().min(1),
    title: z.string(),
    body: z.string().default(''),
    state: z.enum(['open', 'closed']),
    author: z.string().default(''),
    labels: z.array(z.string()).default([]),
    assignees: z.array(z.string()).default([]),
    milestone: z.string().default(''),
  })
  .strict()
export type GitIssueSpec = z.infer<typeof gitIssueSpec>

export const gitIssueStatus = z.object({
  state: z.enum(['open', 'closed']),
  task_id: z.string().optional(),
  writebacks: z.array(writeBack).optional(),
  writeback_error: z.string().optional(),
  last_touched: z.string(),
})
export type GitIssueStatus = z.infer<typeof gitIssueStatus>

export const pullRequestSpec = z
  .object({
    source,
    repo: z.string(),
    number: z.number().int().min(1),
    title: z.string(),
    body: z.string().default(''),
    state: z.enum(['open', 'closed', 'merged']),
    /** the provider's merge time, only on a merged PR */
    merged_at: z.string().optional(),
    author: z.string().default(''),
    draft: z.boolean().default(false),
    labels: z.array(z.string()).default([]),
    requested_reviewers: z.array(z.string()).default([]),
    review_requested: z.boolean().default(false),
    mergeable: z.boolean().nullable().default(null),
    checks: z.enum(['success', 'failure', 'pending', 'unknown']).default('unknown'),
    head: z.string().default(''),
    base: z.string().default(''),
  })
  .strict()
export type PullRequestSpec = z.infer<typeof pullRequestSpec>

export const pullRequestStatus = z.object({
  state: z.enum(['open', 'closed', 'merged']),
  review_state: z.enum(['approved', 'changes_requested', 'commented']).optional(),
  review_task_id: z.string().optional(),
  writebacks: z.array(writeBack).optional(),
  writeback_error: z.string().optional(),
  last_touched: z.string(),
})
export type PullRequestStatus = z.infer<typeof pullRequestStatus>
